declare const __BUILD_ID__: string;

/** The build this bundle came from. Stamped at build time by vite.config.ts. */
export const BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
